import LifecareStudioField from './LifecareStudioField';
import LifecareStudioSectionCard from './LifecareStudioSectionCard';

// The heading/content fields drop their labels since their role is self-evident; the
// numeric field stacks below the heading and keeps its label because the value alone
// is ambiguous.
const LifecareStudioTextSection = ({
  titleFieldName,
  contentFieldName,
  numericFieldName,
  numericLabel,
}) => (
  <LifecareStudioSectionCard>
    <div className="mb-4 flex flex-col gap-4">
      <div className={numericFieldName ? 'md:w-1/3' : undefined}>
        <LifecareStudioField name={titleFieldName} placeholder="Heading" />
      </div>
      {numericFieldName ? (
        <div className="md:w-1/3">
          <LifecareStudioField
            name={numericFieldName}
            label={numericLabel}
            type="number"
            min={0}
          />
        </div>
      ) : null}
    </div>
    <LifecareStudioField name={contentFieldName} placeholder="Content" multiline />
  </LifecareStudioSectionCard>
);

export default LifecareStudioTextSection;
